import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import { useToast } from "../../utils/toast";
import accountService from "../../services/account/account.service";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const toast = useToast();
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [isFormDisabled, setIsFormDisabled] = useState(false);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    
    if (isCodeSent && countdown > 0) {
      setIsFormDisabled(true);
      interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            setIsFormDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isCodeSent, countdown]);

  const formik = useFormik({
    initialValues: {
      email: ""
    },
    validate: (data) => {
      const errors: any = {};
      if (!data.email) {
        errors.email = "E-posta adresi gereklidir";
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
        errors.email = "Geçersiz e-posta adresi";
      }
      return errors;
    },
    onSubmit: async (values) => {
      try {
        const response = await accountService.SendPasswordResetEmail(values);
        if (response.result && !response.result.error) {
          setIsCodeSent(true);
          setCountdown(30);
          toast.show("Sıfırlama kodu başarıyla gönderildi", "success");
        } else {
          toast.show(response?.result?.error || "Bir hata oluştu", "error");
        }
      } catch (error) {
        toast.show("Bir hata oluştu", "error");
      }
    }
  });

  return (
    <div className="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
      <div className="flex flex-column align-items-center justify-content-center">
        <div
          className="surface-card border-1 surface-border border-round-2xl shadow-3 p-4 sm:p-5 md:p-6 w-full"
          style={{ maxWidth: "460px" }}
        >
          <div className="text-center mb-5">
            <Link to="/">
              <img src="/images/logoosbuk.png" alt="OSBÜK Logo" height="48" className="mb-3" />
            </Link>
            <div className="text-900 text-2xl sm:text-3xl font-bold mb-2">Şifre Sıfırlama</div>
            <span className="text-600 text-sm">Şifrenizi sıfırlamak için e-posta adresinizi giriniz</span>
          </div>

          <form onSubmit={formik.handleSubmit}>
            <div className="flex flex-column gap-3">
              <InputText
                id="email"
                name="email"
                type="email"
                placeholder="E-posta adresiniz"
                value={formik.values.email}
                onChange={formik.handleChange}
                className={`${formik.errors.email ? "p-invalid" : ""} p-3 w-full`}
                disabled={isFormDisabled}
              />
              {formik.errors.email && <small className="p-error">{formik.errors.email}</small>}

              <Button 
                label={isFormDisabled ? `Tekrar Gönder (${countdown}s)` : "Sıfırlama Kodu Gönder"} 
                className="w-full p-3 text-base font-semibold" 
                type="submit"
                disabled={isFormDisabled}
              />

              <div className="text-center mt-2">
                <Link to="/loginsebis" className="text-sm font-medium text-primary hover:underline">
                  Giriş Ekranına Dön
                </Link>
              </div>
            </div>
          </form>

          {isCodeSent && (
            <div className="mt-4 p-3 border-round-xl bg-blue-50 border-1 border-blue-100">
              <h4 className="text-primary m-0 mb-2 font-semibold">Sıfırlama Kodu Gönderildi!</h4>
              <p className="m-0 text-sm line-height-3 text-700">E-posta adresinize şifre sıfırlama linki gönderildi. Lütfen:</p>
              <ul className="mt-2 mb-0 pl-3 text-sm text-600">
                <li>Spam/Gereksiz klasörünüzü kontrol etmeyi unutmayın</li>
                <li>Gelen e-postadaki talimatları takip edin</li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
